// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + "7a112eb3ce4bc7f9a2bb" + ".bundle.js";
};